import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import PaginatedTable from "../../sharedComponents/tableWithPagination";
import AddOrDeleteMotivation from "./addOrUpdateMotivation";
import ConfirmDelete from "../../sharedComponents/confirmDelete";
import "./motivationManagement.scss";
import Tooltip from "../../sharedComponents/tooltip";
import PlaceholderImage from "../../sharedComponents/placeholderImage";

export default function MotivationListing({ motivationList, getMotivationList, submitMotivation, deleteMotivation }) {
	const [show, setShow] = useState(false);
	const [initialValues, setInitialValues] = useState({});
	const [motivationId, setMotivationId] = useState(null);
	const [deleteItem, setDeleteItem] = useState(null);
	const [formType, setFormType] = useState(null);
	const [fileType, setFileType] = useState(null);

	const onUpdateButtonClick = (selectedMotivationDetails) => {
		setFormType("Update");
		setMotivationId(selectedMotivationDetails.id);
		if (selectedMotivationDetails.video !== null) {
			setInitialValues({
				title: selectedMotivationDetails.title,
				url: selectedMotivationDetails.video
			});
			setFileType("video");
		} else {
			setInitialValues({
				title: selectedMotivationDetails.title,
				url: selectedMotivationDetails.image
			});
			setFileType("image");
		}
		setShow(true);
	};

	const onToggleButtonClick = (selectedMotivationDetails) => {
		submitMotivation(
			"Update",
			selectedMotivationDetails.video ? "video" : "image",
			{ is_active: !selectedMotivationDetails.is_active },
			selectedMotivationDetails.id
		);
	};

	useEffect(() => {
		handleClose();
	}, [motivationList]);

	const confirmDelete = (original) => {
		setDeleteItem(original);
	};

	const confirmEvent = (yes) => {
		yes ? deleteMotivation(deleteItem) : setDeleteItem(null);
	};

	const handleClose = () => {
		setShow(false);
	};

	const onClickAddButton = () => {
		setShow(true);
		setFormType("Add");
		setFileType(null);
		setInitialValues(null);
	};

	const onClickMotivationType = (string) => {
		setFileType(string);
	};

	const columns = [
		{
			Header: "Thumbnail",
			accessor: "thumbnail",
			width: 130,
			Cell: ({ original: item }) => {
				const itemType = item.video === null ? "image" : "video";
				let image;
				if (itemType === "video") {
					image = item.youtube_id ? `https://img.youtube.com/vi/${item.youtube_id}/1.jpg` : null;
				} else {
					image = item.image;
				}
				return (
					<PlaceholderImage
						src={image}
						width={50}
						height={50}
						bg="rgba(0,0,0,0.1)"
						color="rgba(0,0,0,0.3)"
						objectFit="cover"
					/>
				);
			}
		},
		{
			Header: "Title",
			accessor: "title"
		},
		{
			Header: "ACTIONS",
			accessor: "fat_mass",
			width: 140,
			sortable: false,
			headerClassName: "text-right",
			className: "text-right",
			Cell: ({ original }) => {
				return (
					<div>
						{original.is_active ? (
							<Tooltip content="Disable" placement="left">
								<button
									className="btn btn-primary-dark btn-ghost btn-cell btn-sm mr-2"
									onClick={() => onToggleButtonClick(original)}>
									<i className={`icon icon-not-allowed`} />
								</button>
							</Tooltip>
						) : (
							<Tooltip content="Enable" placement="left">
								<button
									className="btn btn-primary btn-ghost btn-cell btn-sm mr-2"
									onClick={() => onToggleButtonClick(original)}>
									<i className={`icon icon-eye`} />
								</button>
							</Tooltip>
						)}
						<Tooltip content="Edit" placement="left">
							<button
								className="btn btn-success btn-ghost btn-cell btn-sm mr-2"
								onClick={() => onUpdateButtonClick(original)}>
								<i className="icon icon-edit" />
							</button>
						</Tooltip>
						<Tooltip content="Delete" placement="left">
							<button
								className="btn btn-danger btn-ghost btn-cell btn-sm"
								onClick={() => confirmDelete(original)}>
								<i className="icon icon-trash" />
							</button>
						</Tooltip>
					</div>
				);
			}
		}
	];

	return (
		<section className="page page-motivational-management">
			<Container>
				<div className="d-flex w-100 align-items-center mb-3">
					<h3 className="flex-fill m-0">Motivational Content Management</h3>
					<div className="text-right">
						<div className="btn ml-3 btn-primary pointer" onClick={() => onClickAddButton()}>
							<i className="icon icon-plus"></i> Add new
						</div>
					</div>
				</div>
				<Row>
					<Col>
						<PaginatedTable
							data={motivationList && motivationList.results}
							columns={columns}
							totalItems={motivationList && motivationList.count}
							prev={motivationList && motivationList.previous}
							next={motivationList && motivationList.next}
							pageSize={20}
							onPagination={(e) => {
								getMotivationList(`?limit=20&${e}`);
							}}
						/>
					</Col>
				</Row>
				<AddOrDeleteMotivation
					show={show}
					handleClose={handleClose}
					formType={formType}
					fileType={fileType}
					onClickMotivationType={onClickMotivationType}
					initialValues={initialValues}
					submitMotivation={submitMotivation}
					motivationId={motivationId}
				/>
				<ConfirmDelete item={deleteItem} message={<div>Are you sure you want to delete?</div>} onEvent={confirmEvent} />
			</Container>
		</section>
	);
}
